import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ABOUT_ROUTE, HOME_ROUTE, SCHOOL_RESOURCES_ROUTE } from "../../routes/RoutesPathes";
import { CONTACT_EMAIL_1, CONTACT_EMAIL_2 } from "../../constants/constants";

export const Footer = () => {
  const { t, i18n } = useTranslation();
  const textDirection = i18n.dir() === "rtl" ? "text-lg-end" : "text-lg-start";

  return (
    <footer className="bg-black text-white py-4">
      <Container>
        <Row className="align-items-start">
          <Col sm={12} lg={4} className={`${textDirection} text-center`}>
            <div style={{fontSize: "1rem"}}>
              <span>{t("translation:titles.contact_us")}</span><br />
              <a href={`mailto:${CONTACT_EMAIL_2}`} className="text-white text-decoration-none">{CONTACT_EMAIL_2}</a>
              <br />
              <a href={`mailto:${CONTACT_EMAIL_1}`} className="text-white text-decoration-none">{CONTACT_EMAIL_1}</a>
            </div>
          </Col>

          <Col sm={12} lg={4} className="text-center mb-3 mb-md-0">
            <nav className="d-flex justify-content-center gap-3 flex-wrap">
              <Link to={HOME_ROUTE} className="text-white text-decoration-none">{t("pages.home")}</Link>
              <span className="text-white">|</span>
              <Link to={ABOUT_ROUTE} className="text-white text-decoration-none">{t("pages.about")}</Link>
              <span className="text-white">|</span>
              <Link to={SCHOOL_RESOURCES_ROUTE} className="text-white text-decoration-none">{t("pages.resources")}</Link>
            </nav>
            <p style={{color: "#888", fontSize: "0.9rem", marginTop: "0.5rem"}}><span>© {new Date().getFullYear()}</span> {t("titles.copyright")}<span></span></p>
          </Col>

          <Col sm={12} lg={4} className="d-none d-md-block" />
        </Row>
      </Container>
    </footer>
  );
};
